export default "__VITE_PUBLIC_ASSET__458e6b13__"